import { defineEvents } from '@ndrc/app-sdk/events';
export const events = defineEvents({});
